import { render } from "./seleccion-producto-stock-component.vue?vue&type=template&id=05f1497f&scoped=true"
import script from "./seleccion-producto-stock-component.vue?vue&type=script&lang=js"
export * from "./seleccion-producto-stock-component.vue?vue&type=script&lang=js"

import "./seleccion-producto-stock-component.vue?vue&type=style&index=0&id=05f1497f&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\eric.aparicio\\Documents\\REPOS\\ubiku.2023-master\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05f1497f"]])

export default __exports__